export default __webpack_public_path__ + "static/favicon-aed93680560f3bd54453735193f5aec0.png";